import { createGlobalStyle } from 'styled-components';

export const StyledTimePickerOverride = createGlobalStyle`
@media (max-width: 768px) {
  .ant-picker-dropdown {
    display: flex;
    align-items: end;
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    z-index: 1000 !important;
    overflow: auto;
    inset: 0 !important;
    background-color: rgba(0, 0, 0, 0.55) !important;
    touch-action: none;
    margin: 0;
    padding: 0;
  }
  .ant-picker-dropdown * {
    width: 100%;
  }
  .ant-picker-dropdown .ant-picker-time-panel-column {
    overflow: hidden auto;
  }
  .ant-picker-range-arrow {
    display: none !important;
  }
}
  
  
  .ant-picker-time-panel-column {
    width: 47px !important;
  }
  .ant-picker-time-panel-cell {
    display: flex;
    justify-content: center;
    text-align: center !important;
  }
  .ant-input {
    background: transparent !important;
  }
  .ant-picker-time-panel-cell div.ant-picker-time-panel-cell-inner {
    border-radius: .5rem !important;
    width: 31px !important;
    margin: 0 !important;
    padding: 0 !important;
  }
  .ant-picker-time-panel-cell-selected div.ant-picker-time-panel-cell-inner {
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }

  .adm-picker-view-column-item-active div.adm-picker-view-column-item-label {
    color: ${props => props.theme.colors.primary.main.filled} !important;
  }
`;
